import React from 'react';
import { classNames } from '../../utils/classNames';

/** Dashed speech-bubble icon with optional marching-ants stroke. */
export const TemporaryChatIcon = ({ size = 18, animated = true, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={classNames('temporary-chat-icon', className)}
  >
    <path
      d="M12 3.4c-4.55 0-8.25 3.35-8.25 7.5 0 2.2 1.05 4.18 2.72 5.55L5.2 20.3l3.85-1.55c.9.28 1.88.45 2.95.45 4.55 0 8.25-3.35 8.25-7.5S16.55 3.4 12 3.4z"
      className={classNames(
        'temporary-chat-icon-stroke',
        animated && 'temporary-chat-icon-stroke--animated'
      )}
      stroke="currentColor"
      strokeWidth="1.55"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
